import { TableBody as MUITableBody } from '@mui/material';

import { TableRow } from './TableRow';

export const TableBody = ({
  isAdmin,
  isManager,
  reports,
  selectedApptIDs,
  onSelectRow,
  openActivityLogModal,
  openRescheduleDemoModal,
  onChangeReports,
  filterByStatuses,
}) => {
  return (
    <MUITableBody>
      {reports.map((report, idx) => {
        const isRowChecked = selectedApptIDs.includes(report.apptID);
        const withBorderBottom = reports.length !== idx + 1;

        return (
          <TableRow
            key={report.apptID}
            report={report}
            isRowChecked={isRowChecked}
            withBorderBottom={withBorderBottom}
            isAdmin={isAdmin}
            isManager={isManager}
            onSelectRow={onSelectRow}
            openActivityLogModal={openActivityLogModal}
            openRescheduleDemoModal={openRescheduleDemoModal}
            onChangeReports={onChangeReports}
            filterByStatuses={filterByStatuses}
          />
        );
      })}
    </MUITableBody>
  );
};
